export default "__VITE_ASSET__BkmHmiPK__"